import log from 'loglevel';
log.setDefaultLevel('info'); // trace|debug|info|warn|error
window.log = log;

// jQuery
window.$ = window.jQuery = require('jquery/dist/jquery');
// require('jquery-ui/ui/core');
// require('jquery-ui/ui/widgets/accordion');

// Bootstrap
// import 'bootstrap';
// require('bootstrap/js/dist/modal');

// External libraries
// require('slick-carousel');
// require("select2");
// window.tippy = require('tippy.js').default;


// -- require files from contao bundles
// -- context 'Dmkzwo' is defined in webpack.config.js

// var req = require.context("Dmkzwo", true, /init\.js$/);
//
// req.keys().forEach(function(key){
//     req(key);
// });

// use stimulus
import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

import TabsController from "../web/bundles/contaotabs/controllers/tabs_controller"

const application = Application.start()
application.register("tabs", TabsController)

// const application = Application.start()
// const context = require.context("./js/controllers", true, /\.js$/)
// const context = require.context("Dmkzwo", true, /_controller\.js$/)
// const context = require.context("../web/bundles", true, /_controller\.js$/)
// console.log(context)
// application.load(definitionsFromContext(context))

$(document).ready(function() {
    $('.js-chart-table-toggle').on('click', function() {
        $('#' + $(this).data('charttable')).slideToggle();
    });
});
